
import HttpService from "@/utils/httpData"
export default {
    get(classId, subjectName) {
           
        let params= {
            classId: classId,
            subjectName: subjectName
        }
        let apiEndpoint = `subject/Get`;
        return HttpService.get(apiEndpoint, params)
                .then(res => {
                    return res ? res : null;
                })
                .catch(e => {return false}
        );
    },
}